module.exports = function() {
  return new Worker(__webpack_public_path__ + "9609b550311c3de3b50b.worker.js");
};